import styled from '@emotion/styled';

import { SelectableItem } from 'components/inputs/select/styles';

export const FormContainer = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
  padding: 10,
}));

export const SelectedSelectableItem = styled(SelectableItem)(({ theme }) => ({
  background: 'none',
  color: theme.colors.text.primary,
  '&:hover': {
    background: 'none',
  },
}));

export const SelectWrapper = styled.div(() => ({
  maxHeight: 34,
  display: 'flex',
}));
